import { HelpArticle } from "@/components/HelpArticle/HelpArticle";
import { Screenshot } from "@/components/Screenshot/Screenshot";
import { createFileRoute } from "@tanstack/react-router";
import menyLeggTilVedlegg from "./meny-legg-til-vedlegg.png";
import lastOppVedlegg from "./last-opp-vedlegg.png";

const title = "Tinglysing med vedlegg";

export const Route = createFileRoute("/_authenticated-user/hjelp/tinglysing-med-vedlegg/")({
  head: () => ({
    meta: [{ title: `${title} | Alice & Bob` }],
  }),
  component: Page,
});

function Page() {
  return (
    <HelpArticle title={title}>
      <p>Har du behov for å tinglyse med vedlegg? Vi støtter alle vedleggskategoriene Kartverket har åpnet for.</p>

      <p>Kategoriene som støttes er:</p>
      <ul>
        <li>Skifteattest, uskifteattest og bostyrerattest ved dødsboskifte</li>
        <li>Skiftefullmakt</li>
        <li>Testament og ektepakt ved dødsboskifte</li>
        <li>Begrunnelse for dokumentavgift</li>
        <li>Salgsfullmakt</li>
        <li>Kjøpsfullmakt</li>
        <li>Annet</li>
        <li>Gjensidig testament</li>
        <li>Samtykke fra rettighetshaver til urådighet</li>
        <li>Samtykke fra bortfester</li>
      </ul>

      <h2>Slik gjør du det</h2>
      <ol>
        <li>
          Opprett dokumentet som skal tinglyses. Deretter klikker du på de tre prikkene til høyre og får frem
          sidemenyen.
        </li>
      </ol>
      <Screenshot
        src={menyLeggTilVedlegg}
        width={900}
        alt="Et skjøte på oppdraget med menyen bak de tre prikkene åpen, med valget «Legg til vedlegg» nederst."
      />

      <ol start={2}>
        <li>Trykk på vedlegg, velg vedleggskategori og last opp vedlegget.</li>
      </ol>
      <Screenshot
        src={lastOppVedlegg}
        width={900}
        alt="Dialogen «Last opp vedlegg» med opplastingsfelt og nedtrekkslisten «Vedleggskategori» åpen."
      />

      <p>
        Etter du har lastet opp vedlegget skal det komme opp valideringsfeil om at forsendelsen vil gå til manuell
        behandling. Det betyr at det er en fysisk person hos Kartverket som må se over forsendelsen og godkjenne.
      </p>

      <p>Foreløpig støtter ikke Kartverket vedlegg på sletting av heftelser.</p>
    </HelpArticle>
  );
}
